<!--
 * @Author: ZS
 * @Date: 2020-06-09 14:44:54
 * @LastEditors: ZS
 * @LastEditTime: 2020-06-28 14:19:57
 * @Description: file content
-->
<template>
  <div style="background-color:#f1f2f3">
    <div class="mainContent topPart">
      <div class="headerAndNav">
        <v-header></v-header>
        <v-nav :index="navIndex"></v-nav>
      </div>
      <div class="topQuery roleChoose">
        <div class="mainWidth clearfix">
          <!-- <h2 class="partName pull-right">个人中心/<span>User Center</span></h2> -->
          <div class="pageName">门户首页</div>
          <ul class="clearfix noselect">
            <li v-for="(item,index) in typeList" :key="index" :class="{active:typeListIndex == index}"
              @click="typeListClick(index,item.pcGuidelineTypeId)">
              <img src="../../assets/images/serviceType0.png">
              <p>{{item.pcGuidelineTypeName}}</p><span>{{item.pcGuidelineTypeDescription}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="classification mainWidth clearfix">
      <div class="left">
        <ul class="tit clearfix noselect">
          <li class="active" style="width:100%">主题列表</li>
        </ul>
        <div class="content cotnent1 scenes active">
          <ul>
            <li v-for="(item,index) in ztList" :key="index" :class="{active:ztListIndex == index}"
              @click="ztListClick(index,item.pcGuidelineSceneCode)">{{item.pcGuidelineSceneName}}<i
                class="iconfont icon-youjiantou"></i>
              <div class="badge">{{item.num}}</div>
            </li>
          </ul>
        </div>
        <div class="content cotnent2 departmentList">
          <ul class="noselect">
            <li class="active" data-id="">全部<i class="iconfont icon-202-copy"></i></li>
            <li data-id="000002" title="人文社科学部">人文社科学部<i class="iconfont icon-202-copy"></i><span
                class="departBadge">13</span></li>
            <li data-id="000021" title="行政部门">行政部门<i class="iconfont icon-202-copy"></i><span
                class="departBadge">1</span></li>
          </ul>
        </div>
      </div>
      <div class="right">
        <div class="searchCondition">
          <!-- <a href="ywtb_search.html" class="more">
            更多&gt;&gt;
          </a>
          <div class="conditons clearfix">
            <b>事项类型：</b>
            <ul class="clearfix noselect typeOfMatter">
              <li class="active" data-id="">全部</li>
              <li data-id="1">联办审批类</li>
              <li data-id="2">业务办理类</li>
              <li data-id="3">查询服务类</li>
              <li data-id="4">公示公开类</li>
            </ul>
          </div> -->
          <div class="inputSearch">
            <el-input placeholder="请输入内容" v-model="input3">
              <el-button slot="append" class="searchBtn">查询</el-button>
            </el-input>
          </div>
        </div>
        <ul class="ywtbListsContent clearfix noselect">
          <li data-label="学生服务1,管理服务类,校园生活,人文社科学部,联办审批类" class="searchShow">
            <img
              src="http://192.168.30.36:8080/portal-pc/public/getImg?path=%E5%8E%BB%E9%97%AE%E4%B9%94%E6%81%A9%E5%8E%BB">
            <h3 title="事项名12称7">事项名12称7</h3>
            <p title="事项说明">事项说明</p>
            <a href="javascript:;" class="btn btn-primary znBtn" onclick="jumpToItem(88,'0c597c25ce1eec8')">办事指南</a>

            <a href="事项链接" class="btn btn-primary blBtn" target="_blank">立即办理</a>

          </li>

          <li data-label="学生服务1,管理服务类,入学事项,人文社科学部,联办审批类" class="searchShow">
            <img
              src="http://192.168.30.36:8080/portal-pc/public/getImg?path=%E5%8E%BB%E9%97%AE%E4%B9%94%E6%81%A9%E5%8E%BB">
            <h3 title="事项名12称4">事项名12称4</h3>
            <p title="事项说明">事项说明</p>
            <a href="javascript:;" class="btn btn-primary znBtn" onclick="jumpToItem(85,'0c597c25ce1e4e276')">办事指南</a>

            <a href="事项链接" class="btn btn-primary blBtn" target="_blank">立即办理</a>

          </li>

          <li data-label="学生服务1,管理服务类,入学事项,人文社科学部,联办审批类" class="searchShow">
            <img
              src="http://192.168.30.36:8080/portal-pc/public/getImg?path=%E5%8E%BB%E9%97%AE%E4%B9%94%E6%81%A9%E5%8E%BB">
            <h3 title="事项名12称2">事项名12称2</h3>
            <p title="事项说明">事项说明</p>
            <a href="javascript:;" class="btn btn-primary znBtn" onclick="jumpToItem(83,'0c593')">办事指南</a>

            <a href="事项链接" class="btn btn-primary blBtn" target="_blank">立即办理</a>

          </li>

          <li data-label="学生服务1,管理服务类,入学事项,人文社科学部,联办审批类" class="searchShow">
            <img
              src="http://192.168.30.36:8080/portal-pc/public/getImg?path=%E5%8E%BB%E9%97%AE%E4%B9%94%E6%81%A9%E5%8E%BB">
            <h3 title="事项名12称3">事项名12称3</h3>
            <p title="事项说明">事项说明</p>
            <a href="javascript:;" class="btn btn-primary znBtn" onclick="jumpToItem(84,'4')">办事指南</a>

            <a href="事项链接" class="btn btn-primary blBtn" target="_blank">立即办理</a>

          </li>

          <li data-label="学生服务1,管理服务类,校园生活,人文社科学部,联办审批类" class="searchShow">
            <img
              src="http://192.168.30.36:8080/portal-pc/public/getImg?path=%E5%8E%BB%E9%97%AE%E4%B9%94%E6%81%A9%E5%8E%BB">
            <h3 title="事项名12称6">事项名12称6</h3>
            <p title="事项说明">事项说明</p>
            <a href="javascript:;" class="btn btn-primary znBtn" onclick="jumpToItem(87,'d')">办事指南</a>

            <a href="事项链接" class="btn btn-primary blBtn" target="_blank">立即办理</a>

          </li>

          <li data-label="学生服务1,管理服务类,校园生活,人文社科学部,联办审批类" class="searchShow">
            <img
              src="http://192.168.30.36:8080/portal-pc/public/getImg?path=%E5%8E%BB%E9%97%AE%E4%B9%94%E6%81%A9%E5%8E%BB">
            <h3 title="事项名12称8">事项名12称8</h3>
            <p title="事项说明">事项说明</p>
            <a href="javascript:;" class="btn btn-primary znBtn"
              onclick="jumpToItem(89,'0c597c25ce1e4e27a0b9cdc4e')">办事指南</a>

            <a href="事项链接" class="btn btn-primary blBtn" target="_blank">立即办理</a>

          </li>

          <li data-label="学生服务1,管理服务类,入学事项,人文社科学部,联办审批类" class="searchShow">
            <img
              src="http://192.168.30.36:8080/portal-pc/public/getImg?path=%E5%8E%BB%E9%97%AE%E4%B9%94%E6%81%A9%E5%8E%BB">
            <h3 title="事项名12称1">事项名12称1</h3>
            <p title="事项说明">事项说明</p>
            <a href="javascript:;" class="btn btn-primary znBtn"
              onclick="jumpToItem(82,'e5c46a70399a4d1bb403c35dd82bd6bd')">办事指南</a>

            <a href="事项链接" class="btn btn-primary blBtn" target="_blank">立即办理</a>

          </li>

          <li data-label="学生服务1,管理服务类,入学事项,人文社科学部,联办审批类" class="searchShow">
            <img
              src="http://192.168.30.36:8080/portal-pc/public/getImg?path=%E5%8E%BB%E9%97%AE%E4%B9%94%E6%81%A9%E5%8E%BB">
            <h3 title="事项名12称5">事项名12称5</h3>
            <p title="事项说明">事项说明</p>
            <a href="javascript:;" class="btn btn-primary znBtn" onclick="jumpToItem(86,'f')">办事指南</a>

            <a href="事项链接" class="btn btn-primary blBtn" target="_blank">立即办理</a>

          </li>
        </ul>
        <!-- <div class="nullData bszn_null" style="margin-top: 30px;">
          <img src="./ywtb/images/null.png" alt="">
          <p>暂无数据</p>
        </div> -->
        <div class="block" style="text-align:center;padding:10px 0">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="currentPage3" :page-size="100" layout="prev, pager, next, jumper" :total="1000">
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="clearfix mainWidth">
    </div>
    <v-footer :hasInfo=0></v-footer>
    <v-toolBar></v-toolBar>
  </div>
</template>

<script>
  import Footer from '../common/Footer'
  import Header from '../common/Header'
  import TopNav from '../common/TopNav'
  import ToolBar from '../common/ToolBar'
  export default {
    components: {
      'v-footer': Footer,
      'v-header': Header,
      'v-nav': TopNav,
      'v-toolBar': ToolBar
    },
    data() {
      return {
        navIndex: 1,
        typeListIndex: 0,
        input3: '',
        currentPage3: 5,
        typeList: '',
        typeListId: 0,
        ztList: '', //主题列表数据
        ztListIndex: 0,
        ztCode: ''
      }
    },
    mounted() {
      this.findPortalPcGuidelineTypeList();
      this.findDepartmentSceneNumList()
    },
    methods: {
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      },
      // 获取顶部服务类型
      findPortalPcGuidelineTypeList() {
        this.ywtbRequest('/portal-ywtb/web/portalPcGuidelineType/findPortalPcGuidelineTypeList').then((res) => {
            let data = res.dataList
            let TempData = {
              count: null,
              pcGuidelineTypeDescription: "All",
              pcGuidelineTypeId: 0,
              pcGuidelineTypeName: "全部服务"
            }
            data.unshift(TempData)
            this.typeList = data
        })
      },
      // 获取主题列表
      findDepartmentSceneNumList() {
        let sendData = {
          pcGuidelineSceneCode:'',
          pcGuidelineTypeId:''
        }
        this.ywtbRequest('/portal-ywtb/web/portalPcGuidelineSceneGuideline/findDepartmentSceneNumList', sendData)
          .then((res) => {
              let data = res.dataList
              this.ztList = data
          })
      },
      typeListClick(index, id) {
        this.typeListIndex = index
        this.typeListId = id
      },
      // 主题列表点击筛选
      ztListClick(index, code) {
        this.ztListIndex = index
        this.ztCode = code
      }
    }
  }

</script>

<style scoped>
  .topQuery {
    /* background: url(../../../static/images/userBg.png) no-repeat 0px 0px; */
    height: 276px;
    /* background-size: 100% 160%; */
    padding: 0;
  }

  .topQuery>div {
    position: relative;
  }

  .pageName {
    position: absolute;
    top: -43px;
    right: -10px;
    width: 113px;
    height: 33px;
    line-height: 32px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    border: 1px solid rgba(255, 255, 255, .46);
    border-radius: 17px;
  }

  .roleChoose ul {
    display: inline-block;
    margin-top: 93px;
    padding: 0px 96px;
  }

  .roleChoose ul li {
    width: 232px;
    height: 95px;
    background: rgba(255, 255, 255, 0.5);
    float: left;
    margin-right: 20px;
    padding-left: 100px;
    text-align: left;
    position: relative;
    cursor: pointer;
  }

  .roleChoose ul li:nth-child(5) {
    margin-right: 0px;
  }

  .roleChoose ul li p {
    font-size: 16px;
    color: #3B4559;
    margin-top: 19px;
    line-height: 30px;
  }

  .roleChoose ul li.active p {
    color: #fff;
  }

  .roleChoose ul li span {
    color: #57647D;
    font-size: 14px;
  }

  .roleChoose ul li.active span {
    color: #fff;
  }

  .roleChoose ul li img {
    position: absolute;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    top: 17px;
    left: 25px;
  }

  .roleChoose ul li.active {
    background: rgba(71, 114, 189, 1);
  }

  /* 内容 */
  .classification {
    margin-top: 15px;
    margin-bottom: 30px;
    background-color: #fff;
  }

  .classification .left {
    float: left;
    width: 200px;
  }

  .classification .right {
    float: left;
    height: 100%;
    width: 1000px;
    min-height: 740px;
    border-left: 1px solid #E4E4E4;
  }

  .classification .left .tit {
    width: 100%;
  }

  .classification .left .tit li {
    float: left;
    width: 50%;
    cursor: pointer;
    line-height: 48px;
    color: #56585C;
    text-align: center;
    background: rgba(247, 247, 247, 1);
  }

  .classification .left .tit li.active {
    background-color: #1B3E83;
    color: #fff;
  }

  .classification .left .content {
    display: none;
    padding: 5px 12px;
  }

  .classification .left .content.active {
    display: block;
  }

  .classification .left .content>ul>li {
    color: #56585C;
    line-height: 50px;
    border-bottom: 1px solid #E4E4E4;
    padding-left: 2px;
    cursor: pointer;
    position: relative;
    padding-right: 33px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .classification .left .content>ul>li .iconfont {
    position: absolute;
    right: 0px;
    color: #A4A7AD;
    top: 0px;
  }

  .classification .left .content>ul>li:last-child {
    border-bottom: 1px solid #fff;
  }

  .classification .left .content>ul>li.active {
    color: #56585C;
    font-weight: 700;
    color: #1B3E83;
    ;
  }

  .classification .left .content>ul>li.active .iconfont {
    color: #56585C;
    font-weight: 700;
    color: #1B3E83;
  }

  .inputSearch .searchBtn {
    background-color: #1B3E83;
    color: #fff;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border: 1px solid #1B3E83;
  }

  .searchCondition {
    padding: 20px 23px;
    position: relative;
    border-bottom: 1px solid #eaeaea;
  }

  .searchCondition .form-control {
    border: 1px solid #4772BD
  }

  .searchCondition .btn-default:hover {
    border-color: #1B3E83;
  }

  .searchCondition .inputSearch {
    width: 355px;
  }

  .ywtbListsContent {
    padding: 10px 10px;
  }

  .ywtbListsContent li {
    float: left;
    width: 316px;
    height: 152px;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    position: relative;
    padding: 17px 18px 0 80px;
    margin: 10px 5px;
    box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.05);
  }

  .ywtbListsContent li>img {
    width: 48px;
    height: 48px;
    position: absolute;
    top: 17px;
    left: 18px;
  }

  .ywtbListsContent li>h3 {
    font-size: 16px;
    font-weight: 700;
    color: #4B4F58;
    width: 216px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .ywtbListsContent li>p {
    margin-top: 10px;
    width: 216px;
    height: 40px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    color: #95A1B7;
  }

  .ywtbListsContent li>a {
    width: 86px;
    padding: 4px 12px;
    border: 1px solid rgba(71, 114, 189, 1);
    border-radius: 4px;
    margin-top: 20px;
    margin-left: 3px;
  }

  .ywtbListsContent li .znBtn {
    color: #4772BD;
    background-color: #fff;
  }

  .ywtbListsContent li .blBtn {
    color: #fff;
    background-color: #4772BD;
  }

  .classify-list li.active a {
    border: 1px solid;
    color: #fff;
  }

  .classify-list li.active a {
    border-color: #4772BD;
    background-color: #4772BD;
  }

  .sub-search-box {
    height: auto;
    width: 1240px;
    margin-top: 12px;
    margin-left: auto;
    margin-right: auto;
    padding: 20px 12px;
    background-color: #fff;
    overflow: hidden;
  }

  .badge {
    position: absolute;
    top: 14px;
    left: 130px;
    min-width: 20px;
    text-align: center;
    color: #fff;
    background-color: #4F73BF;
    border-radius: 10px;
    line-height: 20px;
    padding: 0 4px;
    font-size: 12px;
  }

</style>



// WEBPACK FOOTER //
// src/components/views/ByTheme.vue